// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/router'
import $ from 'jquery'
import ElementUI from 'element-ui';
import VueQuillEditor from 'vue-quill-editor'

import 'element-ui/lib/theme-chalk/index.css';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as echarts from 'echarts'
import "@/assets/icon/iconfont.css"
import "@/assets/css/common.css"
import ApexCharts from 'vue-apexcharts'


import "swiper/swiper.min.css";


Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
// Vue.use($);
Vue.use(ElementUI);
Vue.use(VueQuillEditor)
Vue.use(ApexCharts)

Vue.component('apexchart',ApexCharts)
// Vue.prototype.pageUrl = "http://127.0.0.1:8086";
Vue.prototype.pageUrl = "https://www.scjdst.com/website-manager";
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  ElementUI,
  VueQuillEditor,
  $
})



// WEBPACK FOOTER //
// ./src/main.js